import { useLocation } from 'react-router-dom'

import { useNavigate } from '@lib/react-router-dom'

import { useAccountReadContext, useAccountWriteContext } from '@context/AccountContextContext'
import { useProductReadContext } from '@context/ProductContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import {
  getApptestRiskScreenProduct,
  isEconomicProfileTestNeeded,
} from '@utils/AccountAccess/accountProductStatuses'
import {
  getProductAppTestRiskAcceptancePath,
  getProductAppropriatenessTestRiskPath,
  isFirstDepositPath,
  useBasePath,
} from '@utils/path'

export const usePostLoginNavigation = (): {
  navigateAfterLogin: () => Promise<void>
} => {
  const navigate = useNavigate()
  const location = useLocation()
  const locale = useSessionLanguage()
  const { refreshAccount } = useAccountWriteContext()
  const { account } = useAccountReadContext()
  const { product } = useProductReadContext()
  const { getBasePath } = useBasePath()

  const navigateAfterLogin = async () => {
    const redirectionPath = new URLSearchParams(location.search).get('redir')

    if (redirectionPath) {
      if (location.pathname.includes('/login/2fa')) {
        navigate(`/login${location.search}`, { replace: true })
      }
      return
    }

    const refreshedAccount = (await refreshAccount(locale)) ?? account
    const postLoginPath = getBasePath(refreshedAccount)
    const appTestRiskProduct = getApptestRiskScreenProduct(refreshedAccount, product)
    const appTestRiskPath =
      appTestRiskProduct && isEconomicProfileTestNeeded(refreshedAccount, appTestRiskProduct)
        ? getProductAppTestRiskAcceptancePath(appTestRiskProduct)
        : appTestRiskProduct
        ? getProductAppropriatenessTestRiskPath(appTestRiskProduct)
        : undefined

    if (appTestRiskPath && !isFirstDepositPath(postLoginPath)) {
      navigate(appTestRiskPath, { replace: true })
      return
    }
  }

  return { navigateAfterLogin }
}
